import styled, { css } from 'styled-components';
import { IconButton } from 'modules/IconButton';
import { pxToRem } from 'modules/spacing';
import { interactiveTransition, themeGet } from 'modules/tetrisTheme';
import { fontSize, formLabel } from 'modules/theme';
export const YEARS_PER_ROW = 4;
const selectedDayStyles = css `
  background-color: ${themeGet('colors.primary.1000')};
  color: ${themeGet('colors.primary.0')};
`;
const selectedYearStyles = css `
  background-color: ${themeGet('colors.primary.1000')};
  color: ${themeGet('colors.gray.0')};
`;
const fadedDayStyles = css `
  color: ${themeGet('colors.gray.400')};
`;
const todayStyle = css `
  background-color: ${themeGet('colors.gray.100')};
`;
export const Container = styled.div `
  display: inline-flex;
  width: 100%;

  &:focus-visible {
    outline: 0;
  }
`;
export const Column = styled.div `
  overflow: hidden;
  width: 100%;
`;
// Use div container because buttons and flex don't play well together
export const DayContainer = styled.div `
  ${fontSize('small', '1')};
  flex: 0 0 ${100 / 7}%;
  display: flex;
  justify-content: center;
  align-items: center;

  &::before {
    content: '';
    padding-top: 100%;
  }
`;
export const DayButton = styled.button.attrs(() => ({
    type: 'button',
})) `
  appearance: none;
  border: none;
  color: ${themeGet('colors.text.200')};
  background-color: ${themeGet('colors.gray.0')};
  width: 75%;
  height: 75%;
  border-radius: ${themeGet('borderRadius.md')};
  font-family: inherit;
  font-size: inherit;
  ${(props) => props.$isToday && todayStyle};
  ${(props) => props.$isSelected && selectedDayStyles};
  ${(props) => !props.$isSameMonth && fadedDayStyles};
  ${interactiveTransition};

  &:not(:disabled):focus-visible {
    outline: 0;
    box-shadow: 0 0 0 ${pxToRem(3)} ${themeGet('colors.primary.200')};
  }

  &:not(:disabled):hover {
    cursor: pointer;
    color: ${themeGet('colors.text.300')};
    background-color: ${themeGet('colors.gray.100')};
    ${(props) => props.$isSelected && selectedDayStyles};
  }

  &:disabled {
    opacity: 0.5;
  }
`;
export const HeaderContainer = styled.header `
  display: flex;
  align-items: center;
  height: ${pxToRem(42)};
  justify-content: space-between;
  gap: ${themeGet('spacing.sm')};
  padding: ${themeGet('spacing.md')};
  border-bottom: solid ${pxToRem(1)} ${themeGet('colors.border.100')};
`;
export const Weekdays = styled.div `
  display: flex;
  height: ${pxToRem(14)};
  margin-top: ${themeGet('spacing.md')};
`;
export const Weekday = styled.div `
  ${formLabel};
  flex: 1 1 ${100 / 7}%;
  text-align: center;
  color: ${themeGet('colors.gray.400')};
`;
export const DatePickerBody = styled.main `
  display: flex;
  flex-wrap: wrap;
`;
export const YearsList = styled.div `
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(${pxToRem(50)}, 1fr));
  padding-right: ${themeGet('spacing.xl')};
  height: ${pxToRem(200)};
  max-height: ${pxToRem(200)};
`;
export const YearButton = styled.button.attrs(() => ({
    type: 'button',
})) `
  appearance: none;
  border: none;
  margin: ${themeGet('spacing.xs')};
  padding: ${themeGet('spacing.sm')} ${themeGet('spacing.xs')};
  color: ${themeGet('colors.text.200')};
  background-color: ${themeGet('colors.gray.0')};
  border-radius: ${themeGet('borderRadius.sm')};
  font-family: inherit;
  font-size: ${themeGet('fontSize.medium')};
  ${(props) => props.$isThisYear && todayStyle};
  ${(props) => props.$isSelected && selectedYearStyles};
  ${interactiveTransition};

  &:not(:disabled):focus-visible {
    outline: 0;
    box-shadow: 0 0 0 ${pxToRem(3)} ${themeGet('colors.primary.200')};
  }

  &:not(:disabled):hover {
    cursor: pointer;
    color: ${themeGet('colors.text.300')};
    background-color: ${themeGet('colors.gray.100')};
  }

  &:disabled {
    opacity: 0.5;
  }
`;
export const LayoutHelperButton = styled(IconButton).attrs({
    type: 'button',
    size: 'xs',
    role: 'presentation',
}) `
  /* Hack to center the YearPickerToggleButton */
  visibility: hidden;
`;
